module.exports = __webpack_public_path__ + "static/btnTip.900c2ec4.png";